<main *ngIf="!isLoading" id="brandedLoginPage" 
  [class]="brandClass"
  [class.qr-code-scanner-active]="isQrScannerRunning$ | async">
  <zbp-back-to-website-link *ngIf="!isHighlights" class="static-position-top-left"></zbp-back-to-website-link>
  <div class="login-wrapper">
    <div *ngIf="!isHighlights" class="login-wedges login-wedges--left">
      <img class="login-wedge" src="assets/zbportal/img/wedge-top-left.svg" alt="" role="presentation">
      <img class="login-wedge" src="assets/zbportal/img/wedge-middle-left.svg" alt="" role="presentation">
      <img class="login-wedge" src="assets/zbportal/img/wedge-bottom-left.svg" alt="" role="presentation">
    </div>
    <!-- HL Portal and ZB Designs are slightly different, but similar enough to reuse the same component -->
    <div class="content-pane" [ngClass]="isHighlights ? 'col-lg-6 col-xl-6 col-xxl-6 col-sm-10 col-xs-12' : ''">
      <figure class="brand-logo-container">
        <img class="brand-logo-img" [src]="logoSrc" [alt]="logoAlt">
      </figure>
      <div class="login-form-container">
        <zbp-login-form [isQrScannerRunning$]="isQrScannerRunning$"></zbp-login-form>
      </div>
      <!-- HL Portal footer spans half page width -->
      <zbp-footer *ngIf="isHighlights" class="w-100"></zbp-footer>
    </div>
    <div *ngIf="!isHighlights" class="login-wedges login-wedges--right">
      <img class="login-wedge" src="assets/zbportal/img/wedge-top-right.svg" alt="" role="presentation">
      <img class="login-wedge" src="assets/zbportal/img/wedge-middle-right.svg" alt="" role="presentation">
      <img class="login-wedge" src="assets/zbportal/img/wedge-bottom-right.svg" alt="" role="presentation">
    </div>
  </div>
  <!-- ZB Portal footer spans full page width -->
  <zbp-footer *ngIf="!isHighlights" class="w-100"></zbp-footer>
</main>
 